export default __webpack_public_path__ + "static/media/ROTATE_BLACK.a269662c.svg";